import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_MANAGE_TRANSLATIONS } from 'app-support/permissions/Permissions'
import React from 'react'
import { Switch } from 'react-router-dom'

import Translations from './Translations'
import { translationsRoute } from 'routes/routeNames'

const TranslationsContainer: React.FC<{}> = () => (
  <Switch>
    <PermissionRoute permission={PERMISSION_MANAGE_TRANSLATIONS} exact path={translationsRoute} component={Translations} />
  </Switch>
)

export default TranslationsContainer
